
import type { PropType } from 'vue'
import type { KpiEnum } from '../enums/kpi.enum'
import { defineComponent } from 'vue'
import { UiTooltip } from './keen-ui'

export default defineComponent({
  name: 'KpiBar',
  components: {
    UiTooltip,
  },
  props: {
    kpi: {
      type: Object as PropType<{ id: KpiEnum; percentage: number; label?: string }>,
      required: true,
    },
    totalPercentageValue: {
      type: Number,
      default: 100,
    },
    animation: {
      type: Object as PropType<{ duration: number; delay?: number; appear?: boolean }>,
      default: () => ({ duration: 500 }),
    },
    color: {
      type: String,
      default: () => 'primary',
    },
  },
  data() {
    return {
      baseClass: 'epb-kpi-bar',
    }
  },
  computed: {
    tooltipText(): string {
      const percentageText = `${this.kpi.percentage.toLocaleString(this.$epb.locale, {
        maximumFractionDigits: 3,
      })}%`
      if (this.kpi.label) {
        return `${this.kpi.label} (${percentageText})`
      }
      return percentageText
    },
  },
})
